import * as d3 from "d3";
export const addTooltip = (plotClassName: any) => {
  d3.select(`.plot-container.${plotClassName} .tooltip`).remove();

  return d3
    .select(`.plot-container.${plotClassName}`)
    .append("div")
    .attr("class", "tooltip")
    .style("position", "absolute")
    .style("background-color", "white")
    .style("border", "1px solid #ddd")
    .style("padding", "10px")
    .style("border-radius", "5px")
    .style("z-index", 1000)
    .style("opacity", 0);
};
